"use strict";

var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOLElementProps = useOLElementProps;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _OLElement = _interopRequireDefault(require("../elements/OLElement"));
var _RenderersPropsProvider = require("../context/RenderersPropsProvider");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function getFallbackListStyleTypeFromNestLevel(nestLevel) {
  switch (nestLevel % 3) {
    case 0:
      return 'decimal';

    /* istanbul ignore next */

    case 1:
      return 'upper-alpha';

    /* istanbul ignore next */

    default:
      return 'lower-alpha';
  }
}
function useOLElementProps(props) {
  var config = (0, _RenderersPropsProvider.useRendererProps)('ol');
  return _objectSpread(_objectSpread({}, props), {}, {
    getFallbackListStyleTypeFromNestLevel: getFallbackListStyleTypeFromNestLevel
  }, config);
}
var OLRenderer = function OLRenderer(props) {
  return /*#__PURE__*/_react.default.createElement(_OLElement.default, useOLElementProps(props));
};
var _default = OLRenderer;
exports.default = _default;